import ComplaintOrderDetails from './ComplaintOrderDetails'
export default ComplaintOrderDetails
